import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLevels, fetchStudents } from "../studentSlice";

import StudentCreateModal from "./StudentCreateModal";
import LevelList from "./LevelList/LevelList";
import StudentTable from "./StudentTable/StudentTable";
import StudentSearchBar from "./StudentSearchBar";
import StudentSelectBar from "./StudentSelectBar";
import ManyStudentCreateModal from "./ManyStudentCreateModal";
import GradeIncreaseButton from "./GradeIncreaseButton";

import { filterStudentsByKeyword } from "../studentSlice";

const StudentManagementPage = () => {
  const dispatch = useDispatch();
  const { levels, filteredStudents, loading } = useSelector(
    (state) => state.student
  );
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [isManyStudentModalOpen, setIsManyStudentModalOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [studentList, setStudentList] = useState([]);

  const handleFiltering = () => {
    dispatch(filterStudentsByKeyword(keyword));
  };

  useEffect(() => {
    dispatch(fetchLevels());
    dispatch(fetchStudents());
  }, [dispatch]);

  useEffect(() => {
    setStudentList(filteredStudents);
  }, [filteredStudents]);

  return (
    <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "15% 1fr auto",
          alignItems: "center",
          columnGap: "20px", // 열 간격
          padding: "5px 0",
        }}
      >
        {/* 1열: 첫 요소 (왼쪽 끝 고정) */}
        <div style={{ fontWeight: "bold", fontSize: "18px" }}>재원생 관리</div>

        {/* 2열: 중간 영역 (화면 남은 공간 1fr) */}
        <div
          style={{
            display: "flex", // 중간 영역 안에서도 flex 사용 가능
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "10px", // 중간 요소들 간격
          }}
        >
          <StudentSelectBar />
          <StudentSearchBar
            handleFilter={handleFiltering}
            keyword={keyword}
            setKeyword={setKeyword}
          />
        </div>

        {/* 3열: 마지막 요소 (오른쪽 끝 고정) */}
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            style={{
              padding: "10px 25px",
              backgroundColor: "#FFF",
              border: "1px solid #000000",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            onClick={() => setIsStudentModalOpen(true)}
          >
            + 학생 등록
          </button>
          <button
            style={{
              padding: "10px 25px",
              backgroundColor: "#FFF",
              border: "1px solid #000000",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              marginLeft: "10px",
            }}
            onClick={() => setIsManyStudentModalOpen(true)}
          >
            + 학생 대량 등록
          </button>
          <GradeIncreaseButton />
        </div>
      </div>

      <div
        style={{
          padding: "0px",
          display: "flex",
          justifyContent: "center",
          alignItems: "stretch",
          maxHeight: "calc(100vh - 200px)",
        }}
      >
        {loading && <div></div>}

        <LevelList
          levels={levels}
          allStudentList={filteredStudents}
          setIsStudentModalOpen={setIsStudentModalOpen}
          setStudentList={setStudentList}
          studentList={studentList}
        />

        <StudentTable students={studentList}></StudentTable>

        {isStudentModalOpen && (
          <StudentCreateModal setIsStudentModalOpen={setIsStudentModalOpen} />
        )}
        {isManyStudentModalOpen && (
          <ManyStudentCreateModal
            setIsManyStudentModalOpen={setIsManyStudentModalOpen}
          />
        )}
      </div>
    </div>
  );
};

export default StudentManagementPage;
